import React                  from 'react';
import ReactDOM               from 'react-dom';
import { Route }              from 'react-router';
import { HashRouter }         from 'react-router-dom';
import { Provider }           from 'react-redux';
import App                    from './containers/App';
import Dynamic                from './components/Dynamic';
//import registerServiceWorker from './utils/registerServiceWorker';
import configureStore         from './store/configureStore'
//import LogRocketInit          from './utils/LogRocket'; 
//import { isLoggedIn }         from './utils/authService';
         

import './index.css';

const store = configureStore()

ReactDOM.render((
  <Provider store={store}>
    <HashRouter>
      <div>
        <Route path = '/'           component = {App}     />
        <Route path = '/:component' component = {Dynamic} />
      </div>
    </HashRouter>
  </Provider>
), document.getElementById('root'));
